import { Trans } from "../utils/i18n";
import { hasProducts } from "./orderEntryEnfore";
import {validateEmailRegEx, validatePhoneNumber} from "../Shared/FormField";
import {addressConfigWithInvoice} from "./components/address";
import { VatNumberBox } from "../Shared/VatNumberBox";

export const checkoutNiuConfig = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "enableStepper": true,
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "defaultValues": {
        "private_or_company": "private",
    },
    "groups": [
        {
            "description": <Trans i18nKey={"orderEntry.description"}>Your device is not behaving as you expect? <a href={"https://b2x.com/"} title={'B2X'} target={'_blank'}>B2X</a> support you from here to provide a solution quickly. Please complete the form below and we will get back to you to resolve the situation.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect",
                    "doNotResetForm": true,
                },
            ],
        },
        {
            "heading": <Trans i18nKey="orderEntry.addressContact">Contact information</Trans>,
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "address",
            "fields": [
                // This is how we could use the shopping cart field inside the form
                ({ values, form }) => ({
                    size: "full",
                    component: "shoppingcart",
                    products: values.products,
                    transportProductId: values.transport_product_id,
                    onChangeTransportProduct: (transportProduct) => form.change("transport_product_id", transportProduct.id),
                    onRemoveProduct: (product) => form.change("products", values.products?.filter(p => p?.id !== product.id) ?? []),
                    onUpdateProductQuantity: (productId, amount) => form.change("products", values.products?.map(p => p?.id === productId ? { ...p, amount } : p) ?? []),
                    className: "b2x-shadow-md bg-white p-8 mt-4",
                }),
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <div className="mt-4">
                        <VatNumberBox />
                    </div>,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2><Trans i18nKey={'orderEntry.contactInfo'}>Contact info</Trans></h2>
                    </>,
                },
                ...addressConfigWithInvoice,
            ],
            "conditionFunction": (values, orderEntryState) => {
                return hasProducts(values.products);
            },
        },
        {
            "heading": <Trans i18nKey="common.checkout">Confirmation / Summary</Trans>,
            "description": <Trans i18nKey="orderEntry.termsandconditions.description"></Trans>,
            "id": "terms",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.verifyAccountToPay'}>Verify your information</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "verify_phone_number"
                },
                {
                    "name": "terms_of_service",
                    "label": <Trans i18nKey="orderEntry.termsandconditions.label">I have read and accept the <a href={route('shop.termsandconditions')} target={'_blank'}>Terms & Conditions</a> and the <a href={route('privacy')} target={'_blank'}>Privacy Statement</a></Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                const validAddress = validName && values.housenumber && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);
                const validInvoiceAddress = values.deviating_invoice_address == true ? (values?.invoice_private_or_company === "private" ? (values?.invoice_first_name && values?.invoice_last_name) : values?.invoice_name) && values.invoice_city && values.invoice_street && values.invoice_zip && values.invoice_country_id : true;
                const validTransportProduct = !!values.transport_product_id;

                return validAddress && validInvoiceAddress && hasProducts(values.products) && validTransportProduct;
            },
        }
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                        const validAddress = validName && values.housenumber && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);

                        return values.terms_of_service && orderEntryState?.verificationCodeResponse && !!validAddress && hasProducts(values.products);
                    }
                }
            ]
        }
    ]
}
